export default __webpack_public_path__ + "static/media/1964.dacc5f97.png";